import { render, staticRenderFns } from "./scanned-detail.vue?vue&type=template&id=4cccbfcb&scoped=true"
import script from "./scanned-detail.vue?vue&type=script&lang=js"
export * from "./scanned-detail.vue?vue&type=script&lang=js"
import style0 from "./scanned-detail.vue?vue&type=style&index=0&id=4cccbfcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cccbfcb",
  null
  
)

export default component.exports